import { render } from "./SerialDetail.vue?vue&type=template&id=bb5b06d2&scoped=true"
import script from "./SerialDetail.vue?vue&type=script&lang=js"
export * from "./SerialDetail.vue?vue&type=script&lang=js"

import "./SerialDetail.vue?vue&type=style&index=0&id=bb5b06d2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5b06d2"]])

export default __exports__